import { breakingNews } from "../../../mocks/trendData";

export default function Ticker() {
  const doubled = [...breakingNews, ...breakingNews];
  return (
    <div className="border-b border-background-200 bg-background-100">
      <div className="container-x flex items-center gap-3 overflow-hidden py-2">
        <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-primary-500 px-2.5 py-0.5 text-[11px] font-bold text-background-50">
          <i className="ri-flashlight-fill text-[10px]" aria-hidden="true"></i>
          快讯
        </span>
        <div className="relative flex-1 overflow-hidden" aria-label="滚动快讯">
          <div className="flex w-max animate-ticker items-center gap-8">
            {doubled.map((item, i) => (
              <span
                key={i}
                className="flex items-center gap-2 whitespace-nowrap text-xs font-medium text-foreground-700"
              >
                <i className="ri-arrow-right-up-line text-primary-500" aria-hidden="true"></i>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}